import _ from 'lodash';
import Uuid from '../../../../support/Uuid';

class ComplementoComercioExteriorInputPipe {
  getName() {
    return 'ComercioExterior';
  }

  apply(data, comprobante) {
    const { Complemento } = data;

    if (!Complemento || !Complemento.ComercioExterior) {
      return data;
    }

    let { ComercioExterior } = Complemento;

    let { Destinatario = [], Propietario = [], Mercancias = {}, Receptor = {} } = ComercioExterior;
    let { Mercancia = [] } = Mercancias;

    if (!!Destinatario) {
      Destinatario = _.map(Destinatario, (item) => {
        item.id = Uuid.v4();

        if (!!item.Domicilio) {
          item.Domicilio = _.map(item.Domicilio, (Domicilio) => {
            Domicilio.id = Uuid.v4();

            return Domicilio;
          });
        }

        return item;
      });
    }

    if (!!Propietario) {
      Propietario = _.map(Propietario, (item) => {
        item.id = Uuid.v4();

        return item;
      });
    }

    if (!!Mercancia) {
      Mercancia = _.map(Mercancia, (item) => {
        item.id = Uuid.v4();

        if (!!item.DescripcionesEspecificas) {
          item.DescripcionesEspecificas = _.map(item.DescripcionesEspecificas, (DescripcionesEspecificas) => {
            DescripcionesEspecificas.id = Uuid.v4();

            return DescripcionesEspecificas;
          });
        }

        return item;
      });
    }

    data.Receptor = {
      ...data.Receptor,
      num_reg_id_trib: Receptor.NumRegIdTrib || undefined,
      NumRegIdTrib: Receptor.NumRegIdTrib || undefined,
      residencia_fiscal: Receptor.Domicilio?.Pais ?? null,
    };

    data.Complemento.ComercioExterior = {
      ...ComercioExterior,
      Destinatario: [...Destinatario],
      Propietario: [...Propietario],
      Mercancias: {
        Mercancia: [...Mercancia],
      },
    };

    return data;
  }
}

export default ComplementoComercioExteriorInputPipe;
